import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CardComponent from '../../../components/base/CardComponent';
import PagesHeader from '../../../components/base/PagesHeader';
import ReportLine from '../../../components/report/ReportLine';
import { Finance } from './types';
import { numberSpaceSeparator } from '../../../util/util';

export const PensionableSalaryDetails = ({ data }: { data: Finance[] }) => {
  const { t } = useTranslation();
  return (
    <div className="d-flex salary-specs-wrapper" style={{ paddingBottom: 30 }}>
      {data.map((item, idx) => {
        return (
          <>
            <Col className="mx-2 mt-2 position-relative" key={idx} md="4" xl>
              <PagesHeader pageTitle="Pension Provision Calculation" headingClass="font-black fs-h3" />
              <CardComponent>
                <div className="mt-3">
                  {item.transactions.map((i) => {
                    const salaryCodeName = i.salaryCodeData.name;
                    const salaryCode = i.salaryCodeData.code;
                    const label =
                      i.salaryCodeData.code === 0 ? 'Missing salary code' : `${salaryCodeName} (Code ${salaryCode})`;

                    return (
                      <>
                        <ReportLine
                          key={i['salaryCode']}
                          label={label}
                          value={numberSpaceSeparator(i.amount.toFixed(2))}
                          tooltip={label}
                          type="LABEL_VALUE"
                          className="fs-text-400"
                        />
                      </>
                    );
                  })}
                  <div style={{ borderTop: '1px solid #000000' }}>
                    <ReportLine
                      label={`${t('total')} ${t('pension_based')} ${t('salary')} ${t('base')}`}
                      value={numberSpaceSeparator(item.grossSalary.toFixed(2))}
                      tooltip={`${t('total')} ${t('pension_based')} ${t('salary')}`}
                      type="LABEL_VALUE"
                      className="fs-h3 font-black"
                    />
                    <ReportLine
                      label={t('pension_provision')}
                      value={numberSpaceSeparator(item.preliminaryTax.toFixed(2))}
                      tooltip={t('pension_provision')}
                      type="LABEL_VALUE"
                      className="fs-h3 font-black"
                    />
                    <ReportLine
                      label={t('salary_change')}
                      value={numberSpaceSeparator(item.taxableIcome.toFixed(2))}
                      tooltip={t('salary_change')}
                      type="LABEL_VALUE"
                      className="fs-h3 font-black"
                    />
                    <ReportLine
                      label={`${t('corrected')} ${t('pension_provision')}`}
                      value={numberSpaceSeparator(item.taxableIcome.toFixed(2))}
                      tooltip={`${t('corrected')} ${t('pension_provision')}`}
                      type="LABEL_VALUE"
                      className="fs-h3 font-black"
                    />
                  </div>
                  <div style={{ borderTop: '1px solid #000000' }}>
                    <ReportLine
                      label={`${t('total')} ${t('pension_provision')}`}
                      value={numberSpaceSeparator(item.totalPayable.toFixed(2))}
                      tooltip={`${t('total')} ${t('pension_provision')}`}
                      type="LABEL_VALUE"
                      className="fs-18px"
                    />
                  </div>
                </div>
              </CardComponent>
            </Col>
            {idx % 2 === 0 && (
              <Col
                className="align-self-center mx-4"
                md="4"
                style={{ background: '#5F5F5F', width: 1, height: '100%' }}
              ></Col>
            )}
          </>
        );
      })}
    </div>
  );
};
